import React from "react"
import "./SkeletonCard.css"

export function SkeletonCard({ count = 3 }) {
	return (
		<div className="row g-4">
			{Array.from({ length: count }).map((_, index) => (
				<div key={index} className="col-12 col-md-6 col-lg-4">
					<div className="skeleton-card shadow-sm rounded-3 p-3">
						<div className="skeleton-img mb-3 rounded-2"></div>
						<div className="skeleton-line skeleton-title mb-2"></div>
						<div className="skeleton-line skeleton-text mb-1"></div>
						<div className="skeleton-line skeleton-text mb-1" style={{ width: "80%" }}></div>
						<div className="skeleton-line skeleton-text mb-3" style={{ width: "60%" }}></div>
						<div className="d-flex justify-content-between align-items-center mt-auto">
							<div className="skeleton-line skeleton-badge" style={{ width: "25%", height: "24px" }}></div>
							<div className="skeleton-line skeleton-btn" style={{ width: "30%", height: "30px" }}></div>
						</div>
					</div>
				</div>
			))}
		</div>
	)
}
